import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { fetchBooking, fetchCancellationDetails, resetBookingStore } from '../actions/booking';
import { fetchContractsSnapshot, fetchCancellationContracts, resetContractStore } from '../actions/contracts';
import { CancellationSummaryMain } from '../../app-bookings-cancel/cancellation-summary-main';
import { Spinner } from 'shared-components/decorators/spinner';
import { initAuth } from '../actions/auth';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class CancellationSummaryContainer extends Component {
  componentDidMount () {
    const { profile, accessToken, dispatch, routeParams, iosBookingId } = this.props;

    if (isEmpty(profile.data)) {
      dispatch(initAuth(accessToken));
    }

    if (accessToken) {
      const bookingID = get(routeParams, 'id') || iosBookingId;
      dispatch(fetchBooking(bookingID, accessToken));
      dispatch(fetchContractsSnapshot(bookingID, accessToken));
      dispatch(fetchCancellationContracts(bookingID, accessToken));
      // cancel details for non-contract bookings
      dispatch(fetchCancellationDetails(bookingID, accessToken));
    }
  }

  componentWillReceiveProps (nextProps) {
    const { accessToken, booking, contract } = nextProps;
    const isOldPolicy = get(booking, 'booking.cancellation_policy.is_old_cancel');
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    // if user logs out, redirect to sign in
    if (!accessToken) {
      window.location.href = `${urlPrefix ? `/${urlPrefix}` : ''}/`;
    }
    // Only allow booking with new cancellation policy to view summary page
    if (isOldPolicy) {
      window.location.href = '/inbox';
    }
  }

  componentWillUnmount () {
    const { dispatch } = this.props;
    dispatch(resetContractStore());
    dispatch(resetBookingStore());
  }

  render () {
    const { isFetching, contract, booking, iosBookingId, cancellationObj } = this.props;
    const updatedBooking = get(this.props, 'booking.booking._id') === (get(this.props, 'params.id') || iosBookingId);

    return (
      <div className="CancellationSummaryContainer">
        { (isFetching || isEmpty(contract.data) || !updatedBooking || isEmpty(booking.booking) || isEmpty(cancellationObj))
          ? <div className="spinner-container">
              <Spinner additionalStyle="gray" />
            </div>
          : <CancellationSummaryMain {...this.props} />
        }
      </div>
    );
  }
}

CancellationSummaryContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  accessToken: PropTypes.string.isRequired,
  routeParams: PropTypes.object.isRequired,
  booking: PropTypes.object,
  contract: PropTypes.object,
  contracts: PropTypes.object
};

function mapStateToProps (state) {
  const { auth, profile, booking, contract } = state;
  const contracts = get(contract, 'data.contracts');
  const contractCancellationObj = get(contract, 'cancellationObj');
  const bookingCancellationObj = get(booking, 'bookingCancellationObj', {});
  // use cancellation obj from contracts if it was a contracts cancellation
  const cancellationObj = !isEmpty(get(contractCancellationObj, 'contracts')) ? contractCancellationObj : bookingCancellationObj;
  const displayError = get(contract, 'error') || get(booking, 'error');

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  return {
    auth,
    profile,
    isFetching,
    booking,
    contract,
    contracts,
    cancellationObj: cancellationObj,
    displayError: displayError
  };
}

export default connect(mapStateToProps)(CancellationSummaryContainer);
